import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';

import Publications from 'components/BKantarciPublications/Publications';

import MobileFooter from 'components/MobileFooter';

function Kantarcipublication() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Publications/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Publications/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Kantarcipublication;
